import React from 'react';
import { useModal, Body, Button, styled, Title } from '@teko/ds-desktop';
import { CautionOutlined } from '@teko/ds-icon';
import { t } from '../../i18n.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const WarningChangePaymentMethod = (_a) => {
  var _b = _a, { onClick } = _b, props = __objRest(_b, ["onClick"]);
  const { showModal } = useModal();
  const showConfirmModal = () => {
    showModal == null ? void 0 : showModal({
      children: /* @__PURE__ */ React.createElement(Body, {
        level: 1,
        style: { textAlign: "center" }
      }, t("Khi thay \u0111\u1ED5i th\xF4ng tin \u0111\u01A1n h\xE0ng thanh to\xE1n l\u1EA1i, \u0111\u01A1n hi\u1EC7n t\u1EA1i s\u1EBD b\u1ECB h\u1EE7y. Gi\xE1 v\xE0 khuy\u1EBFn m\u1EA1i \u0111\u01A1n h\xE0ng c\xF3 th\u1EC3 b\u1ECB thay \u0111\u1ED5i. B\u1EA1n c\xF3 ch\u1EAFc ch\u1EAFn mu\u1ED1n th\u1EF1c hi\u1EC7n thao t\xE1c n\xE0y?")),
      title: /* @__PURE__ */ React.createElement(Title, {
        level: 3
      }, t("Th\xF4ng b\xE1o")),
      onOk: onClick,
      size: "s",
      okText: t("X\xE1c nh\u1EADn"),
      cancelText: t("H\u1EE7y"),
      centeredTitle: true,
      cancelButtonProps: {
        size: "s"
      },
      okButtonProps: {
        size: "s"
      },
      showCloseIcon: true,
      alignFooter: "center",
      fullWidthFooter: true
    });
  };
  return /* @__PURE__ */ React.createElement(StyledWarning, __spreadValues({}, props), /* @__PURE__ */ React.createElement(CautionOutlined, {
    color: "pending600",
    size: 24
  }), /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: "pending600",
    marginLeft: "s4"
  }, t("Tr\u01B0\u1EDDng h\u1EE3p mu\u1ED1n thay \u0111\u1ED5i h\xECnh th\u1EE9c thanh to\xE1n ho\u1EB7c c\xE1c th\xF4ng tin kh\xE1c, vui l\xF2ng"), "\xA0", /* @__PURE__ */ React.createElement(Button, {
    variant: "link",
    onClick: showConfirmModal
  }, t("B\u1EA5m v\xE0o \u0111\xE2y"))));
};
const StyledWarning = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.pending100};
  line-height: 40px;
  padding: 0.5rem;
  gap: 0.25rem;
  svg {
    min-width: 24px;
  }
`;

export { WarningChangePaymentMethod };
